import type { ThemeComponents } from '@chakra-ui/react';

import { styleConfig as accordion } from './accordion';
import { styleConfig as actionButton } from './action-button';
import { styleConfig as avatar } from './avatar';
import { styleConfig as button } from './button';
import { styleConfig as checkbox } from './checkbox';
import { styleConfig as drawer } from './drawer';
import { styleConfig as drawerBody } from './drawer-body';
import { styleConfig as drawerCloseButton } from './drawer-close-button';
import { styleConfig as drawerContent } from './drawer-content';
import { styleConfig as drawerHeader } from './drawer-header';
import { styleConfig as drawerOverlay } from './drawer-overlay';
import { styleConfig as formLabel } from './form-label';
import { styleConfig as heading } from './heading';
import { styleConfig as icon } from './icon';
import { styleConfig as input } from './input';
import { styleConfig as link } from './link';
import { styleConfig as menu } from './menu';
import { styleConfig as modal } from './modal';
import { styleConfig as modalHeaderBar } from './modal-header-bar';
import { styleConfig as modalOverlay } from './modal-overlay';
import { styleConfig as numberInput } from './number-input';
import { styleConfig as progress } from './progress';
import { styleConfig as radio } from './radio';
import { styleConfig as select } from './select';
import { styleConfig as skeleton } from './skeleton';
import { styleConfig as spinner } from './spinner';
import { styleConfig as switchStyle } from './switch';
import { styleConfig as tabs } from './tabs';
import { styleConfig as tag } from './tag';
import { styleConfig as text } from './text';
import { styleConfig as textarea } from './textarea';
import { styleConfig as tooltip } from './tooltip';

export const componentStyles: ThemeComponents = {
  Tooltip: tooltip,
  Textarea: textarea,
  Text: text,
  Tag: tag,
  Tabs: tabs,
  Switch: switchStyle,
  Spinner: spinner,
  Skeleton: skeleton,
  Select: select,
  Radio: radio,
  Progress: progress,
  NumberInput: numberInput,
  ModalOverlay: modalOverlay,
  ModalHeaderBar: modalHeaderBar,
  Modal: modal,
  Menu: menu,
  Link: link,
  Input: input,
  Icon: icon,
  Heading: heading,
  FormLabel: formLabel,
  DrawerOverlay: drawerOverlay,
  DrawerHeader: drawerHeader,
  DrawerContent: drawerContent,
  DrawerCloseButton: drawerCloseButton,
  DrawerBody: drawerBody,
  Drawer: drawer,
  Checkbox: checkbox,
  Button: button,
  Avatar: avatar,
  ActionButton: actionButton,
  Accordion: accordion,
};
